import React from 'react';
import Header from '../Header/Header';
import PageContainer from '../Page/PageContainer';
import PageTitle from '../Page/PageTitle';
import Meta from '../Meta/Meta';
import styled from 'styled-components';
import { rem } from 'polished';
import { theme, mediaUp } from '../../globalStyle';

const PrivacyPolicyPageContainer = styled(PageContainer)`
  padding-bottom: ${rem(75)};
  
  ${mediaUp.lg`
    padding-bottom: ${rem(172)};
  `}
`;

const PrivacyPolicyContent = styled.div`
  ${mediaUp.lg`
    width: 60%;
    margin: 0 auto;
  `}
`;

const PrivacyPolicyTitle = styled.h3`
  margin-bottom: 0.5rem;
`;

const PrivacyPolicyCopy = styled.p`
  strong {
    color: ${theme.tertiary};
    font-weight: ${theme.avenirWeightHeavy};
  }
`;

const PrivacyPolicyLink = styled.a`
  color: ${theme.bodyColor};
  
  &:hover {
    color: ${theme.bodyColor};
  }
`;

function PrivacyPolicy() {
  return (
    <React.Fragment>
      <Meta title="Privacy Policy" />

      <Header />

      <PrivacyPolicyPageContainer backgroundLight={true} headerOffset={true}>
        <PageTitle>Privacy Policy</PageTitle>

        <PrivacyPolicyContent>
          <PrivacyPolicyCopy>
            For the purposes of the EU General Data Protection Regulation 2016 (the “GDPR”) Swapcoins is the controller of personal information provided by you on Swapcoins.com (“Swapcoins”) and is responsible for the website swapcoins.com (the “Site”).
            <br />
            <br />
            The term “personal information” as used in this policy shall mean any information that enables us to identify you, directly or indirectly, by reference to an identifier such as your name, identification number, location data, online identifier or one or more factors specific to you. By accessing and using our Site, you signify acceptance to the terms of this Privacy Policy. Where we require your consent to process your personal information, we will ask for your consent to the collection, use, and disclosure of your personal information as described further below.
            <br />
            <br />
            Please take a moment to read this Privacy Policy carefully. If you have any questions about this Privacy Notice, please contact us at <PrivacyPolicyLink href="mailto:support@swapcoins.com">support@swapcoins.com</PrivacyPolicyLink>
            <br />
            <br />
            You are free to choose whether to provide us with all the types of personal information requested by us, but we may not be able to serve you as effectively or offer you all of our services on the Site when you do choose not to share certain information with us. For example, we collect personal information as many laws require the same for carrying out a crypt-based transaction. In the event you choose to not provide the said details to us, your use of the services on our Site shall be limited to the websites which do not have a legal requirement in this regard.
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>OUR DATA PRIVACY PRINCIPLES</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            <ol>
              <li>
                Swapcoins will acquire, use and provide appropriate personal information, giving consideration to the business content and scale, with respect to the personal data collected from you.
              </li>
              <li>
                Swapcoins will specify the purpose of the use of personal information and take appropriate measures to ensure the use of personal information does not exceed that purpose.
              </li>
              <li>
                Swapcoins will comply with laws regarding the use of personal information, policies set by the government and other related regulations.
              </li>
              <li>
                Swapcoins will establish a security management system to prevent a leak, loss, deletion or damage of personal information. Moreover, we will take appropriate corrective and preventive measures for accidents relating to personal information. In the event, there is any breach in the security measures with respect to your personal data, Swapcoins shall notify you.
              </li>
              <li>
                Swapcoins will promptly respond to requests for disclosure of, inquiries about and complaints regarding personal information, by the establishment.
              </li>
              <li>
                Swapcoins will review and appropriately improve the information security management system from time to time as per the applicable laws and accepted industry standards.
              </li>
            </ol>
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>YOUR PRIVACY RIGHTS</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            <strong>For European residents only.</strong> We collect and process personal information about you only in the aforementioned circumstance and where we have a legal requirement to prevent fraud and identify the customers transaction on the Site given the nature of the services provided on our Site, to ensure compliance to applicable laws. The legal bases will depend on the purpose for which we process your personal information. This means we collect and use your personal information only where:

            <ul>
              <li>
                We need it to provide the services, including to operate the Site, provide customer support and personalized features and to protect the safety and security of the Site;
              </li>
              <li>
                It satisfies a legitimate interest (which is not overridden by your rights and interests), such as for research and development, to market and promote the Site and to protect our legal rights and interests;
              </li>
              <li>
                You give us consent to do so for a specific purpose; or
              </li>
              <li>
                We need to process your personal information to comply with a legal obligation or requests from governmental or statutory authorities.
              </li>
            </ul>
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>Rights of the User</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            In certain circumstances, you have rights under the GDPR in relation to your personal information. These data privacy rights do not apply to Swapcoins where we process your personal information as a data processor on behalf of our clients. Where this is the case, any request to exercise your data privacy rights should be directed to our client (i.e. the data controller).

            <ul>
              <li>
                <strong>Request access to your personal information.</strong> You may have the right to request access to any personal information we hold about you as well as related information, including the purposes for processing the personal information, the recipients or categories of recipients with whom the personal information has been shared, where possible, the period for which the personal information will be stored, the source of the personal information, and the existence of any automated decision making.
              </li>
              <li>
                <strong>Request correction of your personal information.</strong> You may have the right to obtain without undue delay the rectification of any inaccurate personal information we hold about you.
              </li>
              <li>
                <strong>Request erasure of your personal information.</strong> You may have the right to request that personal information held about you is deleted.
              </li>
              <li>
                <strong>Request restriction of processing your personal information.</strong> You may have the right to prevent or restrict processing of your personal information.
              </li>
              <li>
                <strong>Request transfer of your personal information.</strong> You may have the right to request transfer of personal information directly to a third party where this is technically feasible.
              </li>
            </ul>
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>WHAT INFORMATION DO WE COLLECT?</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            We use different methods to collect personal information from and about you. We can classify the same into two heads – the Information provided by you and the information collected by us.
          </PrivacyPolicyCopy>

          <PrivacyPolicyCopy>
            <strong>Personal information you give us.</strong>
            <br />
            You may give us your personal information including full name and contact details, by filling in forms or by corresponding with us by email. This includes personal information you provide when you ask us about, or register to use our services; subscribe to our publications; request marketing to be sent to you, or give us feedback. You provide us with your full name, email address at the time of opening an account with us on the Site. At each junction, the information mandatory for successful delivery of the service through the Site shall be informed to you along with the optional information that may or may not be provided by you.
          </PrivacyPolicyCopy>

          <PrivacyPolicyCopy>
            <strong>Emails</strong>
            <br />
            From time to time, we may send out emails for promotional purposes, for service announcements, news, promotions and contests. Our customers may opt-out of receiving these emails. We may use a third-party service provider to send out emails or to communicate smoothly with our customers. For a smoother communication, we may share information, such as your email address, to the service provider for this limited purpose only. You can opt out by following the unsubscribe instructions included in these emails, or you can contact us by email us on support@swapcoins.com or by visiting our support page https://swapcoins.com/faq
          </PrivacyPolicyCopy>

          <PrivacyPolicyCopy>
            <strong>Personal information we collect.</strong>
            <br />
            As you interact with our Site, we may automatically collect technical information about your equipment, browsing actions and patterns, the date you have accessed on our Site, the website you have visited before visiting our Site, your browser, Operating Systems, IP address, and the domain name. We collect this personal information by using cookies, server logs and other similar technologies. The content recorded on access logs is not used in conjunction with personal information. It is used as server operation information to assist in improving our Site and services.
          </PrivacyPolicyCopy>

          <PrivacyPolicyCopy>
            <strong>Regarding Cookies</strong>
            <br />
            Like many websites, we also use ‘Cookies’ to make our Site more convenient to our customers. Cookies are small pieces of data that are transferred between a Web server and your Web browser, and stored on your computer or mobile device as a file.  We mainly use Cookies for the following purposes.

            <ul>
              <li>
                To ensure you do not enter a password every time you use the service.
              </li>
              <li>
                On our Site, we use Cookies to deliver personalized experiences to our customers to deliver our services.
              </li>
              <li>
                Cookies are used for analytics practices to help us understand your activities on our Site.
              </li>
              <li>
                Cookies are also used to give relevant or product related data/information by using marketing services like Reddit, Twitter etc. as specified in the next section.
              </li>
            </ul>

            You may disable the function of Cookies by choosing the browser’s configuration. Please note that this may result in you not being able to use all or part of the services on our Site.
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>WHY DO WE COLLECT AND PROCESS THIS PERSONAL INFORMATION?</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            Some of our core services on the Site are subject to laws and regulations applicable on our partner exchanges and requiring us to collect and use and store your personal identification information, formal identification information for the purposes of identification and fraud prevention. For example, swapcoins must identify customers using the services on the Site in order to comply with anti-money laundering and terrorist financing laws across jurisdictions.  In addition, we use third parties to verify your identity by comparing the personal information you provided against third-party databases and public records. The consequences of not processing your personal information for such purposes is the termination of your account as we cannot perform the services on the Site in accordance with legal and regulatory requirements.  EEA Residents: For individuals who reside in the European Economic Area (including the United Kingdom) or Switzerland pursuant to Article 6 of the EU General Data Protection Regulation (GDPR), we process this personal information to comply with our legal obligations.
          </PrivacyPolicyCopy>

          <PrivacyPolicyCopy>
            <strong>Marketing</strong>
            <br />
            We share your data with third party service providers and online market platforms like Reddit, Twitter, Mailchimp, etc. for marketing and promotion of our Site and to make the advertising more relevant for the end-users. If you do not want Swapcoins to share your data with third parties for the promotion of the Site, please contact us by emailing on support@swapcoins.com or by visiting our support page https://swapcoins.com/faq
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>HOW DO WE PROCESS INFORMATION?</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            We will use your personal information for the following purposes:

            <ul>
              <li>
                To confirm your identity;
              </li>
              <li>
                To respond to your questions and provide related customer services;
              </li>
              <li>
                To detect and prevent fraud or other financial crime;
              </li>
              <li>
                To monitor and protect the security of our information, systems and network;
              </li>
              <li>
                For internal business intelligence purposes, to conduct research, product development and enhancement;
              </li>
              <li>
                To inform you of changes made to our Site and other services;
              </li>
              <li>
                To conduct marketing and commercial activities and to market relevant offers and promotions to you;
              </li>
              <li>
                To ensure that content from our Site is presented most effectively for you and your computer; To display content based on your interests;
              </li>
              <li>
                Enable you to search information on our Site;
              </li>
              <li>
                Assess your needs and interests in order to better tailor offers and/or advertising; and Improve our Site.
              </li>
            </ul>
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>WITH WHOM DO WE SHARE THIS PERSONAL DATA?</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            We share your information with third party identity verification services in order to prevent fraud. This allows Swapcoins to confirm your identity by comparing the information you provide us to public records and other third party databases. These service providers may create derivative data based on your personal information that can be used solely in connection with provision of identity verification and fraud prevention services. We share such information for a limited purpose to comply with our legal obligations, such as anti-money laundering laws. In some cases, we may process additional data about you to ensure our services are not used fraudulently or for other illicit activities. In such instances, processing is necessary for us to continue to perform our contract with you and others.  We may share your information with law enforcement, officials, or other third parties when we are compelled to do so by a subpoena, court order, or similar legal procedure, or when we believe in good faith that the disclosure of personal information is necessary to prevent physical harm or financial loss, to report suspected illegal activity or to investigate violations of our User Agreement or any other applicable policies.  We may share your information with third party service provides for information security and fraud detection and for prevention of illegal activities, in the event we are of the opinion that For European residents only. We collect and process personal information about you only in the aforementioned circumstance and where we have a legal requirement to prevent fraud and identify the customers transaction on the Site given the nature of the services provided on our Site, to ensure compliance to applicable laws. The legal bases will depend on the purpose for which we process your personal information. This means we collect and use your personal information only where:

            <ul>
              <li>
                We need it to provide the services, including to operate the Site, provide customer support and personalized features and to protect the safety and security of the Site;
              </li>
              <li>
                It satisfies a legitimate interest (which is not overridden by your rights and interests), such as for research and development, to market and promote the Site and to protect our legal rights and interests;
              </li>
              <li>
                You give us consent to do so for a specific purpose; or
              </li>
              <li>
                We need to process your personal information to comply with a legal obligation or requests from governmental or statutory authorities.
              </li>
            </ul>
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>HOW DO WE PROTECT YOUR PERSONAL INFORMATION?</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            We will store your personal information, in a form which permits us to identify you, for no-longer than is necessary for the purpose for which the personal information is processed. We and use your personal information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements and rights, or if it is not technically and reasonably feasible to remove it. Otherwise, we will seek to delete your personal information within a reasonable timeframe upon receipt of an electronic request.  We understand how important your privacy is, which is Swapcoins maintains appropriate physical, technical and administrative safeguards to protect the security and confidentiality of the personal information you entrust to us.  Furthermore, we cannot ensure or warrant the security or confidentiality of information you transmit to us or receive from us by Internet or wireless connection, including email, phone, or SMS, since we have no way of protecting that information once it leaves and until it reaches us. If you have reason to believe that your data is no longer secure, please contact us at the email address, mailing address or telephone number listed at the end of this Privacy Policy.
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>STORAGE OF PERSONAL INFORMATION</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            If you are located in, or a resident of EU, you specifically and voluntarily consent to the transfer of your personal information to our servers in Singapore for storage, collection and use of your personal data, for the specific purposes of performing identity verification or checking, to enable us to prevent fraud and comply with our legal obligations.  You may revoke your consent to this section at any time by emailing us at: support@swapcoins.com.
          </PrivacyPolicyCopy>

          <PrivacyPolicyTitle>CONTACT US</PrivacyPolicyTitle>
          <PrivacyPolicyCopy>
            If you have consented to our use of personal information about you for a specific purpose, you have the right to request for deletion of the same.  If you have any questions regarding our policy or privacy practices, please contact us by email at support@swapcoins.com or by visiting our support page https://swapcoins.com/faq
          </PrivacyPolicyCopy>
        </PrivacyPolicyContent>
      </PrivacyPolicyPageContainer>
    </React.Fragment>
  )
};

export default PrivacyPolicy;
